import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {}

interface Variables {
    input: {
        applicationStageFileId: string,
        fileId: string | undefined,
    }[]
}

export const SUBMIT_UPLOAD_STAGE_FILES: TypedDocumentNode<Result, Variables> = gql`
    mutation SubmitUploadStageFiles($input: [ApplicationStageFileInput!]!) {
        submitUploadStageFiles(input: $input) {
            id
        }
    }       
`
